import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { AuthContext } from '../AuthContextProvider';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import { getTZDateTimeAsString } from '../utils/DateUtils';
import * as Constants from '../Constants';
import EventStatus from './EventStatus';

import '../App.css';

const TodaysScheduledEventList = () => {
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { user } = useContext(AuthContext);
  
  const fetchEvents = async () => {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let tomorrow = new Date(today.getTime() + Constants.MS_DAY);
    const params = {
      _site: user._site._id,
      shownOn : {$gt: today, $lt: tomorrow}
    };
    rpc({
      method: "GetScheduledEvents",
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: onSuccess
    });
  }; 
  const fetch = useCallback(fetchEvents, [user]);

  useEffect(() => {
    fetch();
  }, [fetch]);
  
  useEffect(() => {
    const timer = setInterval(() => {
      fetch();
    }, 15000); // Refresh every 15 seconds    
    return () => {
      // Clean up the timer when the component unmounts
      clearInterval(timer);
    };
  }, [fetch]);

  const onSuccess = (events) => {
    setEvents(events);
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const getEventGroups = (event) => {
    return event._eventGroups.map((group) => group.displayName).join(', ');
  };

  const getLinkTarget = (event) => {
    let link = '';
    const text = getTZDateTimeAsString(event.shownOn, user._site.timezone);
    if (event._event.type === Constants.EVENT_JITSI) {
      link = `/videoConferenceEvent/${event._id}`;
    } else if (event._event.type === Constants.EVENT_BINGO) {
      link = `/bingoEvent/${event._id}`;
    } else if (event._event.type === Constants.EVENT_VIDEO) {
      link = `/videoEvent/${event._id}`;
    }
    if (link === '') {
      return text;
    } else {
      return <Link to={link}>{text}</Link>;
    }
  };

  const getStatus = (event) => {
    return Constants.EVENT_STATUS_TEXT[EventStatus.getEventStatus(event)];
  };

  const getTableRow = (event) => {
    if (event._event.type === Constants.EVENT_TEXT_EVENT) {
      return null;
    }
    if (event._event.type === Constants.EVENT_VIDEO) {
      const playAttr = event._event.attributes.find((attr) => {
        return (attr.name === Constants.ATTR_PLAY_IMMEDIATELY);
      });
      if (playAttr?.value === 'true') {
        return null;
      }
    }
    return (
      <TableRow key={event._id}>
        <TableCell>{getLinkTarget(event)}</TableCell>
        <TableCell>{event._event.displayName}</TableCell>
        <TableCell>{getEventGroups(event)}</TableCell>
        <TableCell>{Constants.EVENT_NAMES[event._event.type]}</TableCell>
        <TableCell>{getStatus(event)}</TableCell>
      </TableRow>
    );
  };

  return (
    <div className="TodaysScheduledEventList">
      <Typography variant="h6" gutterBottom>
        Today Events
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Shown On</b></TableCell>
              <TableCell><b>Event</b></TableCell>
              <TableCell><b>Groups</b></TableCell>
              <TableCell><b>Type</b></TableCell>
              <TableCell><b>Status</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => {
              return getTableRow(event);
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default TodaysScheduledEventList;
